<template lang="pug">
    div
        v-dialog(
            v-model="dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            scrollable
            )
            v-card(tile)
                v-toolbar(dark='' :color='colors.primary')
                    v-btn(icon='' dark='' @click.native='dialog = false')
                        v-icon close
                    v-toolbar-title Nuevo Cliente
                customer-form(@createCustomer="createCustomer")
                
        
        customer-search(
            ref="customerSearch"
            v-model="showSearchModal"
            @customer:set="handleCustomerSearch($event)"
            )
        v-toolbar(:color="colors.primary" dark height="50")
            .title RECEPTOR 
            v-btn(
                small
                :color="colors.secondary"
                style="position:absolute; right: 30px; top: 3px;"
                @click="showSearchModal = true"
                :disabled="customerReadonly"
                ) 
                v-icon search
                span Buscar Cliente
            v-btn(
                small
                :color="colors.secondary"
                style="position:absolute; right: 200px; top: 3px;"
                @click="dialog = true"
                :disabled="customerReadonly"
                ) 
                v-icon person
                span Crear Cliente
        v-card
            v-form(ref='form' v-model='validate' lazy-validation='')
                v-layout.pa-3(row wrap)
                    v-flex(sm6 md6) 
                        //rut-input.mx-3(
                            :textFieldProps="{readonly: false}" 
                            ref="rut" 
                            v-model="rut" 
                            @input="updateStateOnInput()"
                            @valid="onValidRut($event)"
                            )
                        v-text-field(
                            ref="rut"
                            v-model="rut"
                            label="rut"
                            readonly
                            :mask="rutInputMask"
                            :readonly="customerReadonly"
                            )
                    //v-flex(
                        sm2
                        md2
                        align-self-start
                        )
                        v-progress-circular(indeterminate :color='colors.primary' v-show='loadingCustomer' )
                        //- v-btn(fab dark color='indigo' :disabled='!rutValido' v-on:click='searchContribuyente()')
                        //-     v-icon(dark) search
                    //businessName
                    v-flex(sm6 md6)
                        v-text-field(readonly v-model='businessName'  :counter='100' label='Razón Social' prepend-icon='short_text' )
                    //coreBusiness
                    //- v-flex(sm6 md6)
                    //-     v-text-field.pl-3.pr-3(readonly v-model='coreBusiness'  :counter='40' label='Giro' prepend-icon='short_text' )
                    //MultipleCoeBusiness
                    v-flex(sm12 md12)
                        v-select(
                            label="Giro"
                            :items='multipleCoreBusiness'
                            placeholder="Giro"
                            v-model='gCoreBusinnesSiiId'
                            item-text="core_business"
                            :readonly="customerReadonly"
                            item-value="id" )
                        //- v-select.pl-5.pr-3(
                        //-     label="Giro"
                        //-     :items='multipleCoreBusiness'
                        //-     placeholder="Giro"
                        //-     v-model='activeCoreBusiness'
                        //-     item-text="core_business"


                        //- v-select.pl-3.pr-3(:items='arrCoreBusinness' v-model='coreBusiness' :value="coreBusiness" label='Giro' :rules="[v => !!v || 'Giro es requerido']" prepend-icon='recent_actors' required='required')
                    v-flex(sm12 md12)
                        v-select(
                            label="Sucursal"
                            :items='branchOfficeOptions'
                            v-model="activeOffice"
                            :readonly="customerReadonly"
                            )
                    v-flex.xs12
                        b Cupo Disponible: {{availableCredit}}
                    //address
                    //v-flex(sm6 md6)
                        v-text-field.pl-3.pr-3(v-model='address'  :counter='100' label='Direccion recepción' prepend-icon='directions' )
                    // FIXME: Define use of this field
                    //v-flex(sm6 md6)
                        v-text-field.pl-3.pr-3(v-model='comuna'
                            :rules='comunaRules'
                            :counter='30'
                            label='Comuna recepción'
                            prepend-icon='directions'
                            )
                //- v-layout.pt-2(row wrap)
                //-     v-flex(sm12 md12)
                //-         .title.pl-3.pr-3 Tipo transacción
                //-     v-flex(sm6 md6)
                //-         v-select.pl-3.pr-3(v-model='saleTransaction' :items='arrSaleTransaction' item-text='saleType' item-value='id' label='Tipo transacción venta' prepend-icon='recent_actors' required='required' :rules="[v => !!v || 'Transacción es requerido']")
                //-     v-flex(sm6 md6)
                //-         v-select.pl-3.pr-3(v-model='purchaseTransaction' :items='arrSaleTransaction' item-text='purchaseType' item-value='id' label='Tipo transacción compra' prepend-icon='recent_actors' required='required' :rules="[v => !!v || 'Transacción Compra es requerido']")

</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import RutUtils from '@/mixins/RUTUtils'
import RUTInput from '@/components/RUTInput/RUTInput'
import InputValidations from '@/mixins/InputValidations'
import CurrencyUtils from '../../../mixins/CurrencyUtils'
//import ContribuyenteModel from '@/models/DTE/Contribuyente' //cambiar por el actual
//import TransaccionCompra from '@/models/TransaccionCompra'
//import TransaccionVenta from '@/models/TransaccionVenta'
import axios from 'axios'
import apiSale from '@/services/API/Sale'
import { setTimeout } from 'timers'
import { CREATE_NEW_USER } from '@/components/SnackbarModal/SnackbarActions'
import { removeRUTHyphen, addRUTHyphen } from '@/services/RUTFormatter'
import CustomerSearch from '@/components/CustomerSearch/CustomerSearch'
import CustomerForm from '@/views/Client/CustomerForm'

export default {
    data() {
        return {
            validate: false,
            rut: '',
            idCustomer: null,
            businessName: '',
            businessNameRules: [v => !!v || 'Razón social es Requerido'],
            coreBusiness: '',
            coreBusinnesRules: [v => !!v || 'Giro es Requerido'],
            arrCoreBusinness: [],
            address: ' ',
            addressRules: [v => !!v || 'Dirección es Requerido'],
            comunas: null,
            comuna: null,
            comunaRules: [v => !!v || 'Comuna es Requerida'],
            includeCustomer: false,
            loadingCustomer: false,
            showSearchModal: false,
            dialog: false,
            multipleCoreBusiness: [],
            gCoreBusinnesSiiId: null,
        }
    },
    methods: {
        searchContribuyente() {},
        fillForm() {
            console.log(this.customerData, 'customerdata fillfomr')

            this.rut = removeRUTHyphen(this.customerData.rut)
            this.businessName = this.customerData.businessName
            this.coreBusiness = this.customerData.coreBusiness
            this.address = this.customerData.address
            this.comuna = this.customerData.comuna
            this.multipleCoreBusiness = this.customerData.gCoreBusinessSii
            this.gCoreBusinnesSiiId = this.coreBusinessSelected
            //this.$refs.customerSearch.setSearch(this.rut)
            // this.$refs.customerSearch.fetchCustomers(this.customerData.rut)
            // this.$refs.customerSearch.handleClick(0);
            //this.coreBusinnessReceptor =[]
        },

        //nuevos
        ...mapActions('CustomerModule', {
            setCustomerData: 'setCustomerData',
            checkDataStatus: 'checkDataStatus',
            fetchCustomerData: 'fetchCustomerData',
            toggleCreateMode: 'toggleCreateMode',
            setRutCustomer: 'setRutCustomer',
            setActiveOfficeID: 'setActiveOfficeID',
            setCoreBusinessCustomer: 'setCoreBusinessCustomer',
            fetchCustomerBranchOffices: 'fetchCustomerBranchOffices',
            setBranchOffices: 'setBranchOffices',
            setSelectedOffice: 'setSelectedOffice',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        onValidRut: async function(event, rut = this.rut) {
            let auxrut = ''
            if (!event) {
                this.editable = false
                return
            }
            if (rut.length <= 7) return
            this.loadingCustomer = true

            auxrut = rut
            //check idCustomer
            let response = await this.fetchCustomerData(this.idCustomer)
            if (this.customerData.rut != undefined) {
                this.loadingCustomer = false
                //this.setActiveOfficeID(1)
                let payload = {
                    typeMessage: 'success',
                    message: {
                        title: 'Cliente',
                        body: 'Encontrado en Sistema',
                    },
                    timeout: 5000,
                    showProgress: false,
                    showCloseBtn: true,
                    closeBtnMessage: 'cerrar',
                }
                this.initSnackbar(payload)
            } else {
                this.setRutCustomer(auxrut)
                this.loadingCustomer = false
                this.setMessageConfirmSnack(CREATE_NEW_USER)
                let payload = {
                    typeMessage: 'warning',
                    message: {
                        title: 'Cliente No encontrado',
                        body: '¿Deseas registrar al cliente?',
                    },
                    timeout: 10000,
                    showProgress: false,
                    showCloseBtn: true,
                    closeBtnMessage: 'cerrar',
                }
                this.initSnackbar(payload)
            }
        },
        updateStateOnInput() {
            console.log('updateStateOnInput')
        },
        handleCustomerSearch(e) {
            console.log('handleCustomerSearch', e)
            console.log(e.rut)
            this.idCustomer = e.id
            this.onValidRut(true, e.rut)
            this.rut = addRUTHyphen(e.rut)
        },
        createCustomer(event) {
            this.handleCustomerSearch(event)
            this.dialog = false
        },
    },
    watch: {
        // rut: {
        //     handler: function(val, oldVal) {
        //         if (!val || val.length <= 7) {
        //             // this.setCustomerData({})
        //             this.fillForm()
        //         }
        //     },
        // },
        customerData: function(val) {
            if (val.rut) this.fillForm()
            console.log(val, 'watch customerData')
            // this.includeCustomer=true
        },
        responseConfirm: function(val) {
            if (val == CREATE_NEW_USER) {
                this.$router.push('nuevo_cliente')
                this.resetSnackbarState()
            }
        },
        activeCustomerId: {
            immediate: true,
            handler(id) {
                if (id) this.fetchCustomerBranchOffices(id)
                else this.setBranchOffices([])
            },
        },
    },
    components: {
        'rut-input': RUTInput,
        'customer-search': CustomerSearch,
        'customer-form': CustomerForm,
    },
    computed: {
        ...mapState('CustomerModule', {
            customerData: 'customerData',
            coreBusinessSelected: 'coreBusinessSelected',
            branchOffices: 'branchOffices',
            selectedOffice: 'selectedOffice',
            customerReadonly: 'customerReadonly',
        }),
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
        ...mapGetters('CustomerModule', ['activeCustomerCredit']),
        branchOfficeOptions() {
            return this.branchOffices
                ? this.branchOffices.map(o => ({
                      text:
                          (o.g_commune ? o.g_commune.name + ' - ' : '') +
                          o.address,
                      value: o.id,
                  }))
                : [{ text: 'no se encontraron sucursales', value: null }]
        },
        activeOffice: {
            get() {
                return this.selectedOffice
            },
            set(v) {
                this.setSelectedOffice(v)
            },
        },
        activeCustomerId() {
            return this.customerData && this.customerData.id
                ? this.customerData.id
                : null
        },
        rutInputMask() {
            let head = ''
            let l = this.rut.length - 1
            for (let i = 1; i <= l; i++) {
                head += '#'
            }
            return head + '-n'
        },
        availableCredit() {
            return this.activeCustomerCredit
                ? this.$options.filters.mixFormatCurrency(
                      this.activeCustomerCredit.available_customer_credit
                  )
                : 'Sin Limite'
        },
        activeCoreBusiness: {
            get() {
                return this.coreBusinessSelected
            },
            set(v) {
                this.setCoreBusinessCustomer(v)
            },
        },
    },
    mixins: [InputValidations, RutUtils, CurrencyUtils],
    beforeMount: function() {
        if (this.customerData.rut != '') {
            this.includeCustomer = true
            this.fillForm()
            console.log(
                '%cTesting customerData',
                'color: white; background-color: lightblue; padding: 2px 5px; border-radius: 2px'
            )
            console.log(this.customerData)
        }
    },
    mounted: function() {
        this.handleCustomerSearch(this.customerData)
    },
}
</script>
<style>
.arrSaleTransaction {
    border: 1px solid black;
    border-collapse: collapse;
}
.success_status {
    background-color: greenyellow;
    color: blue;
    font-weight: bold;
}
.error_status {
    background-color: red;
    color: blue;
    font-weight: bold;
}
</style>
